import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SignPreviewPage } from './sign-preview.page';

const routes: Routes = [
  {
    path: '',
    component: SignPreviewPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SignPreviewPageRoutingModule {}
